module.exports = __webpack_public_path__ + "static/clem-onojegaw-c058841b1dd64e5f79c6348b24cfb78d.jpg";